export const SecurityConstants = {
  authorizeEndpoint : '/oauth2/authorization/google',
  tokenKey :  'authToken',
  serviceKey : 'serviceId',
  buidKey : 'pms-buids',
  roleKey : 'pms-role',
  serviceMapKey : 'pms-service-map',
}